import React from 'react';
import Button from 'src/components/10-atoms/button/Button';
import GenericServerError from 'src/components/10-atoms/GenericServerError';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import Column from 'src/components/10-atoms/layout/Column';
import Row from 'src/components/10-atoms/layout/Row';
import TextLoader from 'src/components/10-atoms/loaders/TextLoader';
import QueryHandler from 'src/components/10-atoms/QueryHandler';
import Page from 'src/components/templates/page/Page.template';
import PageNavbar from 'src/components/templates/page/PageNavbar.template';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import NoteEditorContainer from 'src/modules/exam-preparation/containers/NoteEditor';
import { useNoteDetailsQuery } from 'src/modules/exam-preparation/graphql/notes/getByID';
import useI18n from 'src/modules/translations/hooks/useI18n';
import styleUtils from 'src/utils/styles';
const NoteViewerScreen = ({ navigation, route }) => {
    const { noteID } = route.params;
    const [{ theme, deviceType }] = useTheme(stylesGenerator);
    const { translate } = useI18n();
    const [noteQueryState, noteQueryActions] = useNoteDetailsQuery({
        variables: {
            noteID,
        },
    });
    return (React.createElement(Page, null,
        React.createElement(PageNavbar, { title: noteQueryState.data?.ep_noteDetails?.data.title ?? '', backType: "back", onBackPress: navigation.goBack, bbw: 1 }),
        React.createElement(Column, { flex: true },
            React.createElement(QueryHandler, { queryState: noteQueryState, LoaderComponent: React.createElement(Row, null,
                    !deviceType.isPhone && React.createElement(Column, { style: { width: 280 }, pv: theme.spacing.standard.md, ph: theme.spacing.page, spacingY: theme.spacing.standard.sm }, Array.from({ length: 2 }).map((_, index) => (React.createElement(TextLoader, { key: index, lines: 1, height: 24 })))),
                    React.createElement(TextLoader, { flex: true, lines: 20, height: 24, style: styleUtils.pagePadding, pt: theme.spacing.standard.md })), DataComponent: noteQueryState.data?.ep_noteDetails ? (React.createElement(NoteEditorContainer, { note: noteQueryState.data.ep_noteDetails, editable: false, showHistoryAction: false })) : null, ErrorComponent: React.createElement(GenericServerError, { onRetry: noteQueryActions.fetch }) }),
            noteQueryState.data?.ep_noteDetails ? (React.createElement(Button, { variant: "float", onPress: () => navigation.navigate('EP_NoteEditor', {
                    noteID,
                    editable: true,
                }), LeftIcon: props => React.createElement(FeatherIcon, { name: "edit-2", ...props }) }, translate('Edit Note'))) : null)));
};
const stylesGenerator = createThemedStyle(() => ({}));
export default NoteViewerScreen;
